<template>
    <div>
        <div class="header_unit header_bg_blue">
            <div class="header_box">
                <div class="menu_left">
                    <router-link :to="{ name: 'dailyCheckMenuSnapIndex'} ">戻る</router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_s">{{title}}</p>
                    <p class="menu_center_tex_l">{{dailyCheckPage.dailyCheckPageName}}</p>
                </div>
                <div class="menu_right">
                    <a role="button" @click.prevent.stop="openModel(dailyCheckPage.manualFilePath, modal_type.manual)"><i class="far fa-question-circle"></i> マニュアル</a>
                </div>
            </div>
        </div>

        <div class="main_unit">
            <div class="top_unit">
                <div class="top_name_box">{{getStaffName}}</div>
                <div v-show="!isInitLoading"  class="top_center_box">{{page}}/{{total_page}}</div>
            </div>

            <div>
                <div class="prev_box">
                    <div class="box_fix">
                        <a role="button" @click.prevent.stop="actionCall('befoer')" v-if="page > 1" ><i class="fas fa-chevron-left prev_next_icn"></i><br>前</a>
                    </div>
                </div>
                <div class="next_box">
                    <div class="box_fix">
                        <a role="button" @click.prevent.stop="actionCall('next')" v-if="isDisplayFreeComment ? page < total_page-1 : page < total_page"><i class="fas fa-chevron-right prev_next_icn"></i><br>次</a>
                        <a role="button" @click.prevent.stop="actionCall('nextFree')" v-if="isDisplayFreeComment ? page >= total_page-1 : false"><i class="fas fa-chevron-right prev_next_icn"></i><br>次</a>
                    </div>
                </div>
            </div>

            <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
            <div v-show="!isInitLoading">
                <div class="wd840" >
                    <div class="checkbox_single" style="display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: space-between;align-items: center;">
                        <div v-if="dailyCheckPage.allButtonDisplayFlg">
                            <input type="checkbox" id="01-A" name="checkbox01" :checked="isAllSelected" @click="selectAllCats">
                            <label for="01-A" class="checkbox01" style="display: inline-block !important;">すべて確認</label>
                        </div>
                        <div v-else></div>
                        <p class="checkItem_comment_add_btn_top">コメント枠 追加</p>
                    </div>

                    <div class="checkbox_multiple">
                        <div v-for="ruleList in dailyCheckPage.dailyCheckItemList" :key="ruleList.dailyCheckItemId">
                            <input type="checkbox" name="checkbox01" :id="ruleList.dailyCheckItemId" v-model="selectedCatIds" :value="ruleList.dailyCheckItemId"
                                    :disabled="ruleList.resultValue" v-if="ruleList.resultValue">
                            <input type="checkbox" name="checkbox01" :id="ruleList.dailyCheckItemId" v-model="selectedCatIds" :value="ruleList.dailyCheckItemId"
                                    v-else-if="!ruleList.resultValue"  @click="selectItemClick(ruleList.dailyCheckItemId)">

                            <label class="checkbox01" :for="ruleList.dailyCheckItemId" v-if="ruleList.resultValue">
                              <div class="row justify-content-sm-between align-items-center" >
                                <span class="col-9">{{ruleList.dailyCheckItemName}}</span>
                                <div class="checkItem_comment_add_btn">
                                  <a href="#" @click.prevent.stop="commentDisplayFlgToggle(ruleList.dailyCheckItemId)" v-show="!ruleList.commentDisplayFlg">+</a>
                                  <a href="#" @click.prevent.stop="commentDisplayFlgToggle(ruleList.dailyCheckItemId)" v-show="ruleList.commentDisplayFlg">-</a>
                                </div>
                              </div>

                            </label>
                            <label class="checkbox01" :for="ruleList.dailyCheckItemId" v-else-if="!ruleList.resultValue">
                              <div class="row justify-content-sm-between align-items-center" >
                                <span class="col-9">{{ruleList.dailyCheckItemName}}</span>
                                <div class="checkItem_comment_add_btn">
                                    <a href="#" @click.prevent.stop="commentDisplayFlgToggle(ruleList.dailyCheckItemId)" v-show="!ruleList.commentDisplayFlg">+</a>
                                    <a href="#" @click.prevent.stop="commentDisplayFlgToggle(ruleList.dailyCheckItemId)" v-show="ruleList.commentDisplayFlg">-</a>
                                </div>
                              </div>

                            </label>
                            <div v-show="ruleList.commentDisplayFlg" class="textarea_unit">
                              <textarea class="textarea_box3" placeholder="この項目のコメントを入力" v-model="ruleList.commentText" maxlength="200"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="btnbox">
                        <ul>
                            <li v-for="ruleList in dailyCheckPage.arrangementRuleList" :key="ruleList.arrangementRuleId" >
                                <a role="button" @click.prevent.stop="openModel(ruleList.arrangementRuleFilePath, modal_type.arrangementRule)"><i>配置ルール</i> </a>
                            </li>
                        </ul>
                    </div>
                    <div class="last_update">
                      最後の更新：
                        <div class="right_icn">
                            <a role="button">
                              <p class="icn_red" @click.prevent.stop="openModel(dailyCheckPage.informationFilePath, modal_type.info)"><i class="fas fa-info-circle"></i></p>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="btn_submit letter_spa">
                    <a role="button">登録</a>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd975_d">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit_s"> </p>
                            <p class="modal_header_tit">{{ modal_title }}</p>
                        </div>
                        <div class="modal_header_left">
                            <a role="button" class="js-modal-close"  @click.prevent.stop="closeModel">閉じる</a>
                        </div>
                    </div>
                    <div v-if="fileFormat=='pdf' && pages!==0" class="modal_content_tex2 image_background_color modal_content_pdf">
                        <div class="modal_content_box2">
                            <div class="pdf-container image_background_color">
                                <canvas v-for="page in pages" :id="'canvas' + page" :key="page" class="planCanvas" oncontextmenu="return false;"
                                        height="100%" width="100%" style="height: 100%; width: 100%;"></canvas>
                            </div>
                        </div>
                    </div>
                    <div  v-else-if="fileFormat=='img'" class="modal_content_tex2">
                        <div class="modal_content_box2">
                            <img class="modal_img" :src="modal_image_file_path">
                        </div>
                    </div>
                    <div v-else class="modal_content_tex2">
                        <div class="modal_content_box2">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import PulseLoader from '@/app/components/PulseLoader.vue'
    import PDF from 'pdfjs-dist'
    import PDFJSWorker from '!!file-loader!pdfjs-dist/build/pdf.worker.min.js';
    PDF.GlobalWorkerOptions.workerSrc = PDFJSWorker;

    export default {
        name: "DailyCheckPage",
        components: {
            PulseLoader,
        },
        props: {
            page : Number,
            menuId: Number,
            subMenuId: Number,
        },
        computed:{
            brandPath: function () {
                return this.$store.getters['brand/path']
            },
            getStaffName: function () {
                return  this.$store.getters['staff/data'].staffName;
            },
            menuNameUpper: function () {
                const button = this.$store.getters['buttons/topButton'](this.menuId)
                return 'upperButtonName' in button ? button.upperButtonName : ''
            },
            menuNameLower: function () {
                const button = this.$store.getters['buttons/topButton'](this.menuId)
                return 'lowerButtonName' in button ? button.lowerButtonName : ''
            },
            title: function () {
                const button = this.$store.getters['buttons/dailyCheckButton'](this.menuId, this.subMenuId)
                return 'dailyCheckButtonName' in button ? button.dailyCheckButtonName : ''
            }
        },
        data() {
            return {
                actionStatus:"",
                isInitLoading:true,
                showContent: false,
                modal_image_file_path:"",
                isAllSelected: false,
                selectedCatIds: [],
                selectedItemData:[{daily_check_item_id:null,Value:null}],
                total_page:2,
                commentText:"",
                dailyCheckPage: {
                    dailyCheckPageId: null,
                    dailyCheckPageNo: null,
                    dailyCheckPageName: "",
                    manualFilePath: "",
                    informationFilePath: "",
                    staffName: "",
                    createdTime: "",
                    dailyCheckItemList: [
                        {
                            dailyCheckItemId: null,
                            dailyCheckItemNo: null,
                            dailyCheckItemName: "",
                            resultValue: null,
                            commentText: "",
                            commentDisplayFlg:false,
                        }
                    ],
                    arrangementRuleList: [
                        {arrangementRuleId: null, arrangementRuleNo: null, arrangementRuleFilePath: ""}
                    ],
                    commentHistoryFlg:null,
                    allButtonDisplayFlg:0,
                },
                dailyCheckPageList: [],
                modal_type : {
                    manual: "マニュアル",
                    info: "インフォメーション",
                    arrangementRule: "配置ルール",
                },
                isDisplayFreeComment: false,
                modal_title:"",
                fileFormat:"",
                planFilePath: '',
                pages: 0,
            };
        },
        created: function(){
            this.calc();
        },
        methods: {
            async calc(){
                this.isInitLoading = true;
                var apiResponseFlg = true;

                var brandId = this.$store.getters['brand/id'];
                var topButtonId = this.subMenuId;
                var storeId = this.$store.getters['store/data'].store_id;
                var datetime = this.dateFormat();
                var url = this.$apiEndpoint + 'user/brand/' + brandId + '/daily_menu/' + topButtonId + '/store/' + storeId + '?datetime=' + datetime + '&snapFlg=1';

                await this.$axios
                    .get(url)
                    .then(response => {
                        this.total_page = response.data.dailyCheckContentsList.totalPage;
                        if(this.total_page < 1){
                            throw new Error();
                        }
                        this.dailyCheckPageList = response.data.dailyCheckContentsList.dailyCheckPageList;
                        this.dailyCheckPage = this.dailyCheckPageList[this.page-1];
                    })
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.$route.params.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    })
                    .finally(()=> this.isInitLoading = false);

                // フリーコメントページへのアクセス
                if (this.dailyCheckPage.dailyCheckPageNo == 21) {
                    this.$router.push({ name: 'dailyCheckFreeCommentSnap', params: { menuId: this.menuId, subMenuId: this.subMenuId } })
                }

                // APIエラーの場青、処理終了
                if(!apiResponseFlg){
                    //処理終了
                    return null;
                }

                this.selectedCatIds = [];
                this.selectedItemData = [];

                for (var cat in this.dailyCheckPageList[this.page-1].dailyCheckItemList) {

                    var inputData = new Object();
                    inputData['daily_check_item_id'] = this.dailyCheckPageList[this.page-1].dailyCheckItemList[cat].dailyCheckItemId
                    inputData['Value'] = this.dailyCheckPageList[this.page-1].dailyCheckItemList[cat].resultValue

                    this.selectedItemData.push(inputData);

                    if(this.dailyCheckPageList[this.page-1].dailyCheckItemList[cat].resultValue == 1){
                        this.selectedCatIds.push(this.dailyCheckPageList[this.page-1].dailyCheckItemList[cat].dailyCheckItemId)
                    }
                }

                // フリーコメントページ表示するか
                this.isDisplayFreeComment = this.dailyCheckPageList.filter(x => x.dailyCheckPageNo == 21).length > 0;

                // エラーメッセージ及びコメント入力内容を初期化
                this.commentText ='';

            },
            onPrev() {
                this.actionStatus = "";
                const prev = Math.max(this.page - 1, 1)
                this.$router.push(
                    {
                        name: 'dailyCheckMenuInputSnap',
                        params:{ menuId: this.menuId, subMenuId: this.subMenuId, page: prev }
                    })
            },
            onNext() {
                this.actionStatus = "";
                const next = Math.min(this.page + 1, 20)
                this.$router.push(
                    {
                        name: 'dailyCheckMenuInputSnap',
                        params:{ menuId: this.menuId, subMenuId: this.subMenuId, page: next }
                    })
            },
            selectItemClick(dailyCheckItemId){

                // チェックボタンクリック時
                for(var i = 0 ; i < this.selectedItemData.length ; i++){
                    if (this.selectedItemData[i].daily_check_item_id == dailyCheckItemId){
                        var selectedItem = this.selectedItemData[i];
                        var selectValue = selectedItem['Value'];

                        switch (selectValue) {
                            case 0:
                                selectedItem['Value'] = 1;
                                break;
                            case 1:
                                selectedItem['Value'] = 0;
                                break;
                        }
                        this.selectedItemData.splice(i,1,selectedItem);
                    }
                }
            },
            openModel(value, title) {

                // 拡張子の格納
                if(value !== null && value !== ""){
                    var length = value.length;
                    var searchStrStart = value.lastIndexOf(".",length) ;
                    var searchStrEnd = value.lastIndexOf("?",length) ;
                    var fileFormatStr = value.slice(searchStrStart,searchStrEnd)
                    this.fileFormat = fileFormatStr.replace("?","").replace(".","");
                }

                // PDFと画像の処理判定
                if(this.fileFormat == 'pdf'){
                    // PDF
                    let loadingTask = PDF.getDocument(value);
                    loadingTask.promise.then(pdf => {
                        this.pdfDoc = pdf;
                        this.pages = this.pdfDoc.numPages;
                        this.$nextTick(() => {
                            this.renderPage(1);
                        });
                    }).catch(() => {
                        let error = {
                            button: {
                                path: {name: 'top', params: {brandPath: this.brandPath}}
                            },
                            'message': 'PFDファイルの描画に失敗しました。'
                        };
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(() => this.isInitLoading = false);

                }
                else if(this.fileFormat !== ""){
                    // 画像表示時
                    this.modal_image_file_path = value;
                    this.fileFormat = "img";
                }
                else{
                    // ファイル未設定
                    this.modal_image_file_path = "";
                    this.fileFormat = "";
                }

                this.modal_title = title;
                this.showContent = true;

            },
            renderPage (num) {
                this.pdfDoc.getPage(num).then(page => {
                    // 描画処理
                    let canvas = document.getElementById("canvas" + num);
                    let viewport = page.getViewport({ scale: 0.5, });
                    let desiredWidth = canvas.parentElement.clientWidth;
                    let scale = desiredWidth / viewport.width;
                    let scaledViewport = page.getViewport({ scale: scale, });

                    let ctx = canvas.getContext('2d');
                    canvas.height = scaledViewport.height;
                    canvas.width = scaledViewport.width;

                    let renderContext = {
                        canvasContext: ctx,
                        viewport: scaledViewport
                    };
                    //PDFに複数のページがある場合、複数回レンダリングする
                    page.render(renderContext);
                    if (this.pages > num) {
                        this.renderPage(num + 1);
                    }
                });
            },
            closeModel() {
                this.showContent = false;
            },
            selectAllCats () {
                if (this.isAllSelected) {
                    // 全て外す
                    this.selectedCatIds = []
                    // 表示制御用
                    for (var cat in this.dailyCheckPageList[this.page-1].dailyCheckItemList) {
                        if(this.dailyCheckPageList[this.page-1].dailyCheckItemList[cat].resultValue  == 1){
                            this.selectedCatIds.push(this.dailyCheckPageList[this.page-1].dailyCheckItemList[cat].dailyCheckItemId)
                        }
                    }

                    this.selectedItemData = [];
                    for (var checkOut in this.dailyCheckPageList[this.page-1].dailyCheckItemList) {
                        var inputData = new Object();
                        inputData['daily_check_item_id'] = this.dailyCheckPageList[this.page - 1].dailyCheckItemList[checkOut].dailyCheckItemId;
                        inputData['Value'] = 0;
                        this.selectedItemData.push(inputData);
                    }
                    this.isAllSelected = false
                } else {
                    // 全てチェック
                    this.selectedCatIds = [];
                    // 表示制御用
                    for (var cat2 in this.dailyCheckPageList[this.page-1].dailyCheckItemList) {
                        this.selectedCatIds.push(this.dailyCheckPageList[this.page-1].dailyCheckItemList[cat2].dailyCheckItemId)
                    }

                    this.selectedItemData = [];
                    for (var checkOn in this.dailyCheckPageList[this.page-1].dailyCheckItemList) {
                        var inputData2 = new Object();
                        inputData2['daily_check_item_id'] = this.dailyCheckPageList[this.page - 1].dailyCheckItemList[checkOn].dailyCheckItemId;
                        inputData2['Value'] = 1;
                        this.selectedItemData.push(inputData2);
                    }

                    this.isAllSelected = true
                }
            },
            nextFreeComment(){
                this.$router.push({ name: 'dailyCheckFreeCommentSnap', params: { menuId: this.menuId, subMenuId: this.subMenuId } })
            },
            dateFormat(){
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = ("0" + (nowDate.getMonth()+1)).slice(-2);
                let day = ("0" + nowDate.getDate()).slice(-2);
                let hours = ("0" + nowDate.getHours()).slice(-2);
                let minutes = ("0" + nowDate.getMinutes()).slice(-2);
                let seconds = ("0" + nowDate.getSeconds()).slice(-2);

                let format_str = 'YYYYMMDDhhmmss'
                format_str = format_str.replace(/YYYY/g,year);
                format_str = format_str.replace(/MM/g,month);
                format_str = format_str.replace(/DD/g,day);
                format_str = format_str.replace(/hh/g,hours);
                format_str = format_str.replace(/mm/g,minutes);
                format_str = format_str.replace(/ss/g,seconds);
                return format_str;
            },
            actionCall(status){
                this.actionStatus = status;
                switch (this.actionStatus) {
                    case "befoer":
                        this.onPrev();
                        break;
                    case "next":
                        this.onNext();
                        break;
                    case "nextFree":
                        this.nextFreeComment();
                        break;
                }
            },
            commentDisplayFlgToggle(dailyCheckItemId){
              // コメント追加ボタンクリック時
              for(var i = 0 ; i < this.dailyCheckPage.dailyCheckItemList.length ; i++){
                if (this.dailyCheckPage.dailyCheckItemList[i].dailyCheckItemId == dailyCheckItemId){
                  var selectedItem = this.dailyCheckPage.dailyCheckItemList[i];
                  var selectValue = selectedItem['commentDisplayFlg'];
                  switch (selectValue) {
                    case 0:
                      selectedItem['commentDisplayFlg'] = 1;
                      break;
                    case 1:
                      selectedItem['commentDisplayFlg'] = 0;
                      break;
                  }
                  this.dailyCheckPage.dailyCheckItemList.splice(i,1,selectedItem);
                }
              }
            },
        }
    };
</script>
